export const QUERIES = {
  TAGS: 'TAGS',
} as const

export const tagsKeys = {
  getAllTags: () => [QUERIES.TAGS] as const,
}
